var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestaurantUnselected = function SvgRestaurantUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#restaurant-unselected_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#restaurant-unselected_svg__b)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.255 8.003C16.794 7.847 10 13.818 10 21.576c0 7.936 7 12.606 7 12.606L24 40l7-5.818s7-4.849 7-12.606c0-7.758-6.432-13.42-13.745-13.573Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.255 8.003.01-.5-.01.5ZM24 40l-.32.385a.5.5 0 0 0 .64 0L24 40Zm-7-5.818.32-.385-.02-.017-.023-.014-.277.416Zm14 0-.285-.411-.018.012-.017.014.32.385ZM10.5 21.576c0-7.453 6.538-13.224 13.744-13.073l.021-1C16.549 7.341 9.5 13.513 9.5 21.576h1ZM24.244 8.503C31.319 8.65 37.5 14.122 37.5 21.576h1c0-8.062-6.682-13.915-14.235-14.073l-.021 1Zm.076 31.112-7-5.818-.64.77 7 5.818.64-.77ZM17 34.182l.278-.416-.003-.002-.012-.008a15.17 15.17 0 0 1-1.031-.807 18.703 18.703 0 0 1-2.343-2.409c-1.707-2.105-3.389-5.149-3.389-8.964h-1c0 4.121 1.818 7.38 3.611 9.594a19.707 19.707 0 0 0 2.47 2.538 16.081 16.081 0 0 0 1.052.828 5.047 5.047 0 0 0 .082.056l.005.004.002.001.278-.415Zm20.5-12.606c0 3.724-1.68 6.768-3.39 8.899a19.679 19.679 0 0 1-2.346 2.452 16.004 16.004 0 0 1-.98.795 5.2 5.2 0 0 1-.053.038l-.013.009-.003.002.285.41.285.412.002-.002.005-.003.018-.013.063-.046a17.047 17.047 0 0 0 1.05-.85A20.67 20.67 0 0 0 34.89 31.1c1.79-2.233 3.61-5.492 3.61-9.525h-1Zm-6.82 12.221-7 5.819.64.769 7-5.819-.64-.769Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.8 18.4v4.8h1.8V28h1.2V16c-1.656 0-3 1.344-3 2.4Zm-3 1.8h-1.2V16h-1.2v4.2h-1.2V16H19v4.2a2.4 2.4 0 0 0 2.4 2.4V28h1.2v-5.4a2.4 2.4 0 0 0 2.4-2.4V16h-1.2v4.2Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "restaurant-unselected_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "restaurant-unselected_svg__b",
    x: 3.5,
    y: 5.5,
    width: 41,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_377_456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_377_456",
    result: "shape"
  })))));
};
export default SvgRestaurantUnselected;